import { useEffect, useState, useCallback } from 'react';
import './App.css';
import { nav, profile, experience, education, blog, skills, contact } from './config';
import helloGif from './hello.gif';

function SectionTitle({ title, subtitle }) {
  return (
    <div className="section-title">
      <h2>{title}</h2>
      {subtitle ? <p className="muted">{subtitle}</p> : null}
    </div>
  );
}

function Icon({ name, size = 18 }) {
  const common = { width: size, height: size, viewBox: '0 0 24 24', fill: 'currentColor' };
  switch (name) {
    case 'github':
      return (
        <svg {...common} aria-hidden="true"><path d="M12 .5a11.5 11.5 0 0 0-3.64 22.43c.58.1.8-.25.8-.57v-2c-3.26.71-3.95-1.57-3.95-1.57-.53-1.36-1.3-1.72-1.3-1.72-1.06-.73.08-.72.08-.72 1.18.08 1.8 1.22 1.8 1.22 1.04 1.78 2.72 1.26 3.39.96.1-.77.41-1.26.75-1.55-2.6-.3-5.34-1.3-5.34-5.8 0-1.28.46-2.34 1.22-3.17-.12-.3-.53-1.5.12-3.12 0 0 1-.32 3.28 1.2.95-.27 1.98-.41 3-.41s2.05.14 3 .41c2.28-1.52 3.28-1.2 3.28-1.2.65 1.62.24 2.82.12 3.12.76.83 1.22 1.9 1.22 3.17 0 4.51-2.74 5.5-5.35 5.8.42.36.79 1.07.79 2.17v3.22c0 .32.22.68.8.57A11.5 11.5 0 0 0 12 .5Z"/></svg>
      );
    case 'linkedin':
      return (
        <svg {...common} aria-hidden="true"><path d="M4.98 3.5A2.5 2.5 0 1 1 5 8.5a2.5 2.5 0 0 1-.02-5Zm.02 5.5H2V22h3V9Zm7 0h-3v13h3v-7.2c0-3.87 5-4.19 5 0V22h3v-8.21c0-7.02-8-6.75-8-3.29V9Z"/></svg>
      );
    case 'medium':
      return (
        <svg {...common} aria-hidden="true"><path d="M13.54 12a6.8 6.8 0 0 1-6.77 6.82A6.8 6.8 0 0 1 0 12a6.8 6.8 0 0 1 6.77-6.82A6.8 6.8 0 0 1 13.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"/></svg>
      );
    case 'leetcode':
      return (
        <svg {...common} aria-hidden="true"><path d="M13.483 0a1.374 1.374 0 0 0-.961.438L7.116 6.226l-3.854 4.126a5.266 5.266 0 0 0-1.209 2.104 5.35 5.35 0 0 0-.125.513 5.527 5.527 0 0 0 .062 2.362 5.83 5.83 0 0 0 .349 1.017 5.938 5.938 0 0 0 1.271 1.818l4.277 4.193.039.038c2.248 2.165 5.852 2.133 8.063-.074l2.396-2.392c.54-.54.54-1.414.003-1.955a1.378 1.378 0 0 0-1.951-.003l-2.396 2.392a3.021 3.021 0 0 1-4.205.038l-.02-.019-4.276-4.193c-.652-.64-.972-1.469-.948-2.263a2.68 2.68 0 0 1 .066-.523 2.545 2.545 0 0 1 .619-1.164L9.13 8.114c1.058-1.134 3.204-1.27 4.43-.278l3.501 2.831c.593.48 1.461.387 1.94-.207a1.384 1.384 0 0 0-.207-1.943l-3.5-2.831c-.8-.647-1.766-1.045-2.774-1.202l2.015-2.158A1.384 1.384 0 0 0 13.483 0zm-2.866 12.815a1.38 1.38 0 0 0-1.38 1.382 1.38 1.38 0 0 0 1.38 1.382H20.79a1.38 1.38 0 0 0 1.38-1.382 1.38 1.38 0 0 0-1.38-1.382z"/></svg>
      );
    case 'resume':
      return (
        <svg {...common} aria-hidden="true"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/></svg>
      );
    case 'mail':
      return (
        <svg {...common} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l9 6 9-6M3 6h18v12H3z"/></svg>
      );
    case 'location':
      return (
        <svg {...common} aria-hidden="true"><path d="M12 3a6 6 0 0 0-6 6c0 4.5 6 12 6 12s6-7.5 6-12a6 6 0 0 0-6-6Zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/></svg>
      );
    case 'external':
      return (
        <svg {...common} aria-hidden="true"><path d="M14 3h7v7h-2V6.41l-7.29 7.3-1.41-1.42L17.59 5H14V3ZM5 5h6v2H7v10h10v-4h2v6H5V5Z"/></svg>
      );
    case 'arrow-right':
      return (
         <svg {...common} fill="none" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
      );
    case 'close':
      return (
        <svg {...common} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
      );
    case 'user':
      return <svg {...common} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>;
    case 'briefcase':
      return <svg {...common} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>;
    case 'academic':
      return <svg {...common} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M12 14l9-5-9-5-9 5 9 5z" /><path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" /></svg>;
    case 'book':
      return <svg {...common} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>;
    case 'code':
      return <svg {...common} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" /></svg>;
    case 'chat':
      return <svg {...common} fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" /></svg>;
    default:
      return null;
  }
}

function Modal({ open, onClose, title, children }) {
  useEffect(() => {
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    if (open) { document.addEventListener('keydown', onKey); return () => document.removeEventListener('keydown', onKey); }
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-row">
          <button className="icon-btn" onClick={onClose} aria-label="Close"><Icon name="close" size={20} /></button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}

function useTypingEffect(texts, typingSpeed = 80, deletingSpeed = 40, pauseTime = 2000) {
  const [displayText, setDisplayText] = useState('');
  const [textIndex, setTextIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentText = texts[textIndex];
    let timeout;

    if (!isDeleting && charIndex < currentText.length) {
      timeout = setTimeout(() => {
        setDisplayText(currentText.slice(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      }, typingSpeed);
    } else if (!isDeleting && charIndex === currentText.length) {
      timeout = setTimeout(() => setIsDeleting(true), pauseTime);
    } else if (isDeleting && charIndex > 0) {
      timeout = setTimeout(() => {
        setDisplayText(currentText.slice(0, charIndex - 1));
        setCharIndex(charIndex - 1);
      }, deletingSpeed);
    } else if (isDeleting && charIndex === 0) {
      setIsDeleting(false);
      setTextIndex((textIndex + 1) % texts.length);
    }

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, textIndex, texts, typingSpeed, deletingSpeed, pauseTime]);

  return displayText;
}

function About() {
  const roles = ['Software Engineer', 'Backend Developer'];
  const typedRole = useTypingEffect(roles, 90, 50, 2500);

  return (
    <div className="stack">
      <SectionTitle title="About Me" subtitle={profile.role} />
      <div className="about-hero-card">
        <div className="hero-float-shape hero-float-shape-1" />
        <div className="hero-float-shape hero-float-shape-2" />
        <div className="hero-float-shape hero-float-shape-3" />

        <div className="about-hero-content">
          <div className="about-badge">
            <span className="about-badge-dot" />
            Open for Collaboration
          </div>
          <h1 className="hero-name">
            <span className="greeting-small">{profile.greeting}, I'm</span>
            <span className="name-gradient">{profile.name}</span>
          </h1>
          <div className="hero-role">
            {typedRole}<span className="typing-cursor" />
          </div>
          <p className="hero-summary">{profile.summary}</p>

          <div className="hero-location">
            <Icon name="location" size={16} />
            <span>{profile.location}</span>
          </div>

          <div className="hero-social">
            <a className="hero-social-link" href={contact.links.find(l=>l.label==='LinkedIn')?.href} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" title="LinkedIn"><Icon name="linkedin" size={22} /></a>
            <a className="hero-social-link" href={contact.links.find(l=>l.label==='GitHub')?.href} target="_blank" rel="noopener noreferrer" aria-label="GitHub" title="GitHub"><Icon name="github" size={22} /></a>
            <a className="hero-social-link" href={contact.links.find(l=>l.label==='Medium')?.href} target="_blank" rel="noopener noreferrer" aria-label="Medium" title="Medium Blog"><Icon name="medium" size={22} /></a>
            <a className="hero-social-link" href={contact.links.find(l=>l.label==='LeetCode')?.href} target="_blank" rel="noopener noreferrer" aria-label="LeetCode" title="LeetCode"><Icon name="leetcode" size={22} /></a>
          </div>

          <div className="hero-stats">
            <div className="hero-stat">
              <div className="hero-stat-value">3+</div>
              <div className="hero-stat-label">Years Exp</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-value">3</div>
              <div className="hero-stat-label">Articles</div>
            </div>
          </div>
        </div>

        <div className="about-hero-visual">
          <div className="visual-circle"></div>
          <div className="visual-dots"></div>
          <div className="avatar-container-styled">
            <div className="avatar-frame" />
            <div className="avatar-image" style={{ backgroundImage: profile.avatar ? `url(${profile.avatar})` : undefined }} />
          </div>
        </div>
      </div>
    </div>
  );
}

function Experience() {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(null);

  const handleOpen = useCallback((exp) => {
    setCurrent(exp);
    setOpen(true);
  }, []);

  return (
    <div className="stack">
      <SectionTitle title="Work Experience" subtitle="My professional journey" />

      <div className="experience-timeline">
        {experience.map((exp, i) => {
          const isCurrent = exp.period.toLowerCase().includes('present');
          return (
            <div key={i} className="timeline-item" onClick={() => handleOpen(exp)}>
              <div className="timeline-dot-wrap">
                <div className={`timeline-dot ${isCurrent ? 'current' : ''}`} />
              </div>
              <div className="timeline-card">
                <div className="timeline-company">{exp.company}</div>
                <div className="timeline-role">{exp.role}</div>
                <div className="timeline-period">{exp.period}</div>
                <div className="tech-preview">
                  {exp.tech.slice(0, 4).map(t => <span key={t} className="tech-dot">{t}</span>)}
                  {exp.tech.length > 4 && <span className="tech-dot">+{exp.tech.length - 4}</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <Modal open={open} onClose={() => setOpen(false)} title={current ? current.company : ''}>
        {current && (
          <div className="modal-content-styled">
            <div className="modal-header-styled">
              <div className="modal-company-name">{current.company}</div>
              <div className="modal-role-duration">
                <span className="modal-role">{current.role}</span>
                <span className="modal-divider">/</span>
                <span className="modal-duration">{current.period}</span>
              </div>
            </div>

            <div className="modal-body-styled">
              <ul className="list creative-list">
                {current.items.map((it, idx) => (<li key={idx}>{it}</li>))}
              </ul>

              <div className="modal-tech-tags">
                {current.tech.map(t => (
                  <span key={t} className="modal-tech-tag">{t}</span>
                ))}
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

function Education() {
  return (
    <div className="stack">
      <SectionTitle title="Education" subtitle="Academic background" />
      {education.map((ed, i) => (
        <div key={i} className="education-card">
          <div className="education-icon">
            <Icon name="academic" size={28} />
          </div>
          <div className="education-school">{ed.school}</div>
          <div className="education-period">{ed.period}</div>
          <div className="role-badge">{ed.degree}</div>
          <div className="edu-items">
            {ed.items.map(item => <span key={item} className="edu-item">{item}</span>)}
          </div>
        </div>
      ))}
    </div>
  );
}

function Blog() {
  return (
    <div className="stack">
      <SectionTitle title="Blog" subtitle="Thoughts and technical deep-dives" />
      <div className="blog-list">
        {blog.map((b, i) => (
          <div key={i} className="blog-item" onClick={() => window.open(b.link, '_blank')}>
            <div className="blog-number">{String(i + 1).padStart(2, '0')}</div>
            <div className="blog-main">
              <h3 className="blog-title">{b.title}</h3>
              <p className="blog-excerpt">{b.excerpt}</p>
            </div>
            <div className="blog-icon">
              <Icon name="arrow-right" size={18} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Skills() {
  return (
    <div className="stack">
      <SectionTitle title="Skills" subtitle="Technologies I work with" />
      <div className="skills-container">
        {skills.map((categoryGroup, i) => (
          <div key={i} className="skill-category">
            <h3 className="category-title">{categoryGroup.category}</h3>
            <div className="pill-grid">
              {categoryGroup.items.map((s) => (
                <span key={s} className="pill">{s}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Contact() {
  return (
    <div className="stack">
      <SectionTitle title="Contact" subtitle="Let's build something together" />
      <div className="contact-hero">
        <a href={`mailto:${contact.email}`} className="contact-card primary" style={{ textDecoration: 'none' }}>
          <div className="contact-icon"><Icon name="mail" size={24} /></div>
          <div className="contact-info">
            <div className="label">Email</div>
            <div className="value">{contact.email}</div>
          </div>
        </a>
        <div className="contact-card">
          <div className="contact-icon"><Icon name="location" size={24} /></div>
          <div className="contact-info">
            <div className="label">Location</div>
            <div className="value">{profile.location}</div>
          </div>
        </div>
      </div>

      <div className="social-grid">
        {contact.links.map((l) => {
          const name = l.label.toLowerCase();
          const iconMap = { github: 'github', linkedin: 'linkedin', medium: 'medium', leetcode: 'leetcode', resume: 'resume' };
          return (
            <a key={l.label} href={l.href} className="social-card" target="_blank" rel="noopener noreferrer">
              <Icon name={iconMap[name]} size={28} />
              <span>{l.label}</span>
              <div className="arrow"><Icon name="arrow-right" size={16}/></div>
            </a>
          );
        })}
      </div>
    </div>
  );
}

const sectionMap = {
  about: About,
  experience: Experience,
  education: Education,
  blog: Blog,
  skills: Skills,
  contact: Contact
};

function MobileNav({ active, setActive }) {
  const icons = {
    about: 'user',
    experience: 'briefcase',
    education: 'academic',
    blog: 'book',
    skills: 'code',
    contact: 'chat'
  };

  return (
    <div className="mobile-nav">
      {nav.map((item) => (
        <button
          key={item.key}
          className={active === item.key ? 'mobile-nav-item active' : 'mobile-nav-item'}
          onClick={() => {
            setActive(item.key);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          aria-label={item.label}
        >
          <Icon name={icons[item.key] || 'user'} size={22} />
          {active === item.key && <span className="label">{item.label}</span>}
        </button>
      ))}
    </div>
  );
}

function App() {
  const [active, setActive] = useState('about');
  const Active = sectionMap[active] || About;
  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="brand">
          <div className="brand-hi">{profile.name}</div>
          <div className="brand-role">{profile.role}</div>
          <div className="brand-status">
            <span className="brand-status-dot" />
            Available
          </div>
        </div>
        <nav className="menu">
          {nav.map((item) => (
            <button
              key={item.key}
              className={active === item.key ? 'menu-item active' : 'menu-item'}
              onClick={() => setActive(item.key)}
            >
              {item.label}
            </button>
          ))}
        </nav>
        <div className="sidebar-ornament">
          <img src={helloGif} alt="Hello" className="sidebar-gif" />
        </div>
      </aside>
      <main className="content fade-in" key={active}>
        <Active />
      </main>
      <MobileNav active={active} setActive={setActive} />
    </div>
  );
}

export default App;
